import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByProviderQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByProviderQueryType,
  AnalyticsSalesByProviderQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByProviderQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByProviderQueryType,
    AnalyticsSalesByProviderQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByProviderQueryType,
    AnalyticsSalesByProviderQueryVariablesType
  >(AnalyticsSalesByProviderQuery, options);
};
